import React from 'react'
import { FieldError } from './CreateAccount'
import { SEND_PASSWORD_RESET_EMAIL } from 'requests'

export default class ForgotPasswordForm extends React.Component{
    state = {
        errors: {},
        emailValidationAttempts: 0
    };
    sendPasswordEmail = () => {
        const { emailValidationAttempts } = this.state;

        if (process.env.VALIDATE_EMAIL_BEFORE_SENDING) {
            if (!this.validateEmail(this.email.value)) {
                this.setState((state) => ({
                    errors: {
                        ...state.errors,
                        email: 'Invalid Format',
                    },
                    emailValidationAttempts: state.emailValidationAttempts + 1,
                }));

                //Redirect to the home page if they put in a poorly formatted email address 4 times
                if (emailValidationAttempts >= 3) {
                    window.location.href = '/'; 
                }
                return;
            }
        }

        SEND_PASSWORD_RESET_EMAIL(
            { userId: this.email.value },
            () => {
                this.props.returnAndDisplaySuccess();
            },
            (err) => {
                console.error(err);
                this.setState((state) => ({
                    errors: {
                        ...state.errors,
                        submit:
                            process.env.CUSTOM_RESET_PASSWORD_ERROR_MESSAGE ||
                            'Something went wrong, please try again later.',
                    },
                }));
            }
        );
    };

    validateEmail = (email) => {
        const regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?!.*@)(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/gi;
        return email.trim().length > 0 && regex.test(email);
    };
  render(){
    const { returnToLogin } = this.props;
    return(
      <div className='login forgot-password'>
        <p className='description'>
          {`In order to change your password, please input the ${process.env.RESET_PASSWORD_WITH_USERNAME ? 'username' : 'email'} associated with your account.`}
        </p>
        <div className="field">
          <label>{process.env.RESET_PASSWORD_WITH_USERNAME ? 'Username' : 'Email'}</label>
          <input
            type="text"
            ref={ref => {
              this.email = ref
            }}
            onKeyDown={this.checkEnter}
            placeholder={process.env.RESET_PASSWORD_WITH_USERNAME ? 'username' : 'example@email.com'}
          />
          <FieldError>{process.env.RESET_PASSWORD_WITH_USERNAME ? this.state.errors.username : this.state.errors.email}</FieldError>
        </div>
        <div className="button-wrapper create-wrapper">
          <button
            type="button"
            className="btn-raised btn-light-primary submit"
            onClick={this.sendPasswordEmail}
          >
            SUBMIT
          </button>
        </div>
        <div className="button-wrapper create-wrapper">
          <button
            type="button"
            className="create-account-button"
            onClick={returnToLogin}
          >
            Return to login
          </button>
        </div>
        <FieldError>{this.state.errors.submit}</FieldError>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shell/Login/ForgotPasswordForm.js